import React from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Typography, List, ListItem, ListItemIcon, Link } from '@mui/material';
import * as IconsMaterial from '@mui/icons-material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { tutorialsConsult } from '../../actions/tutorials';
import { useEffect, useState } from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import { useTranslation } from 'react-i18next';
import { errors } from '../../config/errors';


function TutorialsList() {
  const [t, i18next] = useTranslation("global")
  const language = localStorage.getItem('i18nextLng') || 'es'

  const [infoTutorials, setInfoTutorials] = useState([]);
  const [loading, setLoading] = useState(true);

  const createIcon = (icon) => {
  if (icon.name && icon.style){
    const Component = React.createElement(IconsMaterial[icon.name], {
      style: icon.style,
    });
    return Component
  }else{
    return
      <div>
      </div>
  }
}

useEffect(() => {
  const fetchData = async () => {
    try {
      const response = await tutorialsConsult();

      if (response.status === 200) {
        setLoading(false)
        setInfoTutorials(response.response);
      }
    } catch (error) {
      setLoading(true)
      errors.addErroLog(
        {
          data: {
            url: window.location,
            error: error.toString(),
            message: error.message,
            file: error.file,
            line: error.line
          }
        }).then();
      console.error('Error fetching tutorials:', error);
    }
  };

  fetchData();
}, []);

return (
  <div style={{ width: '1000px', margin: 'auto', marginBottom: "150px"}}>
    {loading  &&
      <LinearProgress color="secondary" />
    }
    {infoTutorials.map((category) => (
      <Accordion key={category.id}>
        <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: '#FF6A13' }} />} aria-controls={`panel${category.id}-content`} id={`panel${category.id}-header`}>
          <Typography sx={{ fontWeight: 'bold' }}>{language === 'en' ? category.category_name_english : category.category_name}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <List style={{ background: '#f0f0f0' }}>
            {category.tutorial_info.map((tutorial) => (
              <ListItem key={tutorial.id}>
                <ListItemIcon>
                    {createIcon(tutorial.icon)}
                </ListItemIcon>
                  <Link href={tutorial.url} target="_blank" underline="hover" color="inherit" title={language === 'en' ? tutorial.name_english : tutorial.name}>
                    <Typography sx={{ color: 'purple', fontWeight: 'bold', textDecoration: 'underline' }}>{language === 'en' ? tutorial.name_english : tutorial.name}</Typography>
                  </Link>
              </ListItem>
            ))}
          </List>
        </AccordionDetails>
      </Accordion>
    ))}
  </div>
);



}
export default TutorialsList;